import { render, staticRenderFns } from "./SlideManageView2.vue?vue&type=template&id=2888969e&scoped=true"
import script from "./SlideManageView2.vue?vue&type=script&lang=js"
export * from "./SlideManageView2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888969e",
  null
  
)

export default component.exports